function numToHex( number ) {
	if ( number < 0 ) number = 0xFFFFFFFF + number + 1;

	return number.toString( 16 ).toUpperCase();
}

function getMatrix( rotationMatrix ) {
	let matrix = [], offset = 0, hasRelevantData;

	// ADD EACH 32 BIT HEX STRING (0xFFFF0000) TO MATRIX
	for ( let x = 0; x < 3; x ++ ) {
		let columns = [];

		for ( let y = 0; y < 3; y ++ ) {

			let regex = ( ( y + 1 ) % 3 ) ? /.{1,4}/g : /.{1,6}/g,
				hex16, hex32 = numToHex( dataView.getInt32( rotationMatrix + ( offset * 4 ) ) );

			// CONVERT TO USABLE HEX
			hex32 = hex32.split( '' ).reverse().join( '' );

			// PULL OUT IMPORTANT PART OF HEX CODE
			hex16 = hex32.match( regex )[1];

			if ( hex16 ) {

				hex16 = hex16.split( '' ).reverse().join( '' );

				// CONVERT THE HEX EQUIVALENT INTEGER TO RADIANS AND THEN TO DEGREES
				columns[ y ] = Math.abs( Math.round( Math.asin( parseInt( hex16, 16 ) / ( 1 << 16 ) ) * 180 / Math.PI ) );

				if ( columns[ y ] !== 0 ) hasRelevantData = true;

			// CONVERT THE HEX EQUIVALENT INTEGER TO RADIANS AND THEN TO DEGREES
			} else {

				hex32 = hex32.split( '' ).reverse().join( '' );

				columns[ y ] = Math.abs( Math.round( Math.asin( parseInt( hex32.match( regex, 16 )[0] ) / ( 1 << 16 ) ) * 180 / Math.PI ) );
			}

			offset += 1
		}

		matrix[x] = columns;
	}

	return hasRelevantData ? matrix : false;
}

let getRotation = function( file ) {
	let degrees = [], int8, tkhdAddress = [], mvhdAddress = [];

	window.dataView = new DataView( file );

	int8 = new Int8Array( file );

	// FIND THE ADDRESS OF tkhd
	int8.forEach( function ( element, index ) {

		if ( element === 0x74 && int8[ index + 1 ] === 0x6b && int8[ index + 2 ] === 0x68 && int8[ index + 3 ] === 0x64 ) tkhdAddress.push( index );

		if ( element === 0x6d && int8[ index + 1 ] === 0x76 && int8[ index + 2 ] === 0x68 && int8[ index + 3 ] === 0x64 ) mvhdAddress.push( index );
	} );

	mvhdAddress.forEach( function( address ){

		// HEADER METADATA
		let version = address + 4,
			flags = version + 1,
			creationTime = flags + 3,
			modificationTime = creationTime + 4,
			timeScale = modificationTime + 4,
			duration = timeScale + 4,
			prefRate = duration + 4,
			prefVolume = prefRate + 4,
			reserved = prefVolume + 2,
			rotationMatrix = reserved + 10;

		let parsedMatrix = getMatrix( rotationMatrix );

		parsedMatrix ? degrees.push( getMatrix( rotationMatrix ) ) : null;
	});

	tkhdAddress.forEach( function( address ){

		// HEADER METADATA
		let version = address + 4,
			flags = version + 1,
			creationTime = flags + 3,
			modificationTime = creationTime + 4,
			trackId = modificationTime + 4,
			reserved1 = trackId + 4,
			duration = reserved1 + 4,
			reserved2 = duration + 4,
			layer = reserved2 + 8,
			altGroup = layer + 2,
			volume = altGroup + 2,
			reserved3 = volume + 2,
			rotationMatrix = reserved3 + 2;

		let parsedMatrix = getMatrix( rotationMatrix );

		parsedMatrix ? degrees.push( getMatrix( rotationMatrix ) ) : null;
	});

	return degrees;
};

exports.getRotation = getRotation;


// WEBPACK FOOTER //
// ./src/app/utils/qtff-rotation.js